export const Scan = '/scan';
export const Guest = '/guest';
